// extracted by mini-css-extract-plugin
export default {"ProviderLogo":"ProviderLogo-module__ProviderLogo--XAQ0O"};